<template>
  <div class="pageComplaintsSuggestionsAdd">
    <XR-head :titleText="title" :rightShow="false" ref="headObj"></XR-head>
    <div>     
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="主题" helpText="请输入主题" labelFloat fullWidth v-model="addInfo.Title" />
        </mu-col>
      </mu-row>    
      <mu-row gutter>
        <mu-col width="100" tablet="100" desktop="100" class="rowFiled">
          <mu-text-field label="内容" multiLine :rows="2" :rowsMax="5" :maxLength="100" labelFloat fullWidth v-model="addInfo.content" />
        </mu-col>
      </mu-row>   
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="btn-div">          
          <mu-raised-button label="确 定" class="submit" primary fullWidth @click="submit()" />
        </mu-col>
      </mu-row>  
    </div>
    <XR-toast @onClose="goBack" ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
export default {
  data () {
    return {
      addInfo:{
        UserName:'',
        Title:'',
        Content:'',
        Bz: this.$route.query.bz == 1? this.$route.query.bz:0
      },
      title:this.$route.query.bz==1?'投诉':'建议'
    }
  },
  methods: {    
    submit: function(){
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/AddComplaintsAndSuggestions",
        JSON.stringify(this.addInfo)
      ).then(function(res) {
        if(!res.IsSuccess){
          ths.$refs.XRtoast.failed(res.Msg, true)
        }else{         
          ths.$refs.XRtoast.success(res.Msg, true)
        }
      });
    },
    goBack(){
      this.$router.goBack()
    }
  }
}
</script>
<style>
.pageComplaintsSuggestionsAdd{
  background: white;
}
.pageComplaintsSuggestionsAdd .rowFiled{
  padding: 0 5%;
}
.pageComplaintsSuggestionsAdd .btn-div {
  padding: 20px 5%;
}
.pageComplaintsSuggestionsAdd .submit {
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/ComplaintsSuggestionsAdd.vue